import { useState } from 'react';
import { TextField } from '@recargas-dominicanas/core/components';
import { BusinessUserApi, CustomerApi } from '@recargas-dominicanas/core/api';
import type { IBusinessUser } from '@recargas-dominicanas/core/types';
import { BusinessStore } from '../../../../store/businessStore';
import { Modal } from '../../../../components/modal/modal.component';
import { useForm } from '@recargas-dominicanas/core/hooks';
import { style } from './add-business-user-modal.module.css';

interface Props {
  open: boolean;
  businessId: number;
  onSaved: (businessUser: IBusinessUser) => void;
  onClose: () => void;
}

export function AddBusinessUserModal(props: Props) {

  const { open, businessId, onSaved, onClose } = props;

  const form = useForm({
    name: '',
    userName: {
      value: '',
      minLength: {
        length: 4,
        error: 'El nombre de usuario debe tener mínimo 4 caracteres'
      },
      maxLength: {
        length: 30,
        error: 'El nombre de usuario debe tener máximo 30 caracteres'
      },
      username: true
    }
  }, [open]);

  const [error, setError] = useState<string>();

  async function validateUserName() {

    if (!form.userName.validate()) return false;

    try {
      const result = await CustomerApi.usernameExists(form.userName.value);

      if (result.exists) {
        form.userName.setError('Nombre de usuario no disponible');
        return false;
      }
    } catch {
      form.userName.setError('Error validando nombre de usuario');
      return false;
    }

    return true;
  }

  function handleClose() {
    setError(undefined);
    form.clear();
    onClose();
  }

  async function handleSave() {

    if (!form.validate()) return;

    const isUserNameValid = await validateUserName();

    if (!isUserNameValid) return;

    setError(undefined);

    try {
      
      const businessUser = await BusinessUserApi.add(
        businessId,
        form.userName.value,
        form.name.value
      );

      await BusinessStore.fetchBusinessUsers(businessId);

      onSaved(businessUser);
      handleClose();

    } catch (requestError: any) {

      if (requestError.response?.status === 409) {
        form.userName.setError('Nombre de usuario no disponible');
        return;
      }

      setError('Ocurrió un error al crear el usuario');
    }
  }

  function handleUserNameBlur() {
    validateUserName();
  }

  return (
    <Modal
      open={open}
      style={style.modal}
      title='Agregar usuario'
      error={error}
      primaryButton='Agregar'
      onClose={handleClose}
      onPrimaryClick={handleSave}
      onSecondaryClick={handleClose}>
      <TextField
        style={style.textField}
        label='Nombre'
        value={form.name.value}
        error={form.name.error}
        onChange={form.name.onChange}
        onBlur={form.name.onBlur}/>
      <TextField
        style={style.textField}
        label='Usuario'
        value={form.userName.value}
        error={form.userName.error}
        onChange={form.userName.onChange}
        onBlur={handleUserNameBlur}
        onEnter={handleSave}/>
    </Modal>
  );
}
